import React, { Component } from "react";
import axios from 'axios';
import api from '../api';
import Typography from '@material-ui/core/Typography';
import { withStyles } from "@material-ui/core/styles";
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Button from '@material-ui/core/Button';
import Tier from './Tier'
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = theme => ({
  root: {
    flexGrow: 1,
    width: '100%',
  },
	appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: '2rem',
    flex: 1,
    color: 'white'
  },
  paper: {
    padding: '2rem',
    textAlign: 'center',
  },
  checkedIcon:{
	  width: 16,
      height: 16,
  },
  option:{
  	  fontWeight: 600,
      fontSize:'0.75rem',
  },
  typography:{
	  fontSize: '0.75rem'
  },
  select:{
  	marginTop: '0',
  	marginRight:'12px',
  	padding: '0'
  },
  menu:{
  	fontSize: '0.75rem'
  }
});


class TierChanges extends React.Component {
    constructor(props) {
      	super(props);
		this.state = {work_order_tier_changes:{reason:'',work_order:{user_id:''},
                     tiers:[
                         {tier_type_id: 1, tier_to_show:0, date_change: new Date().toISOString().slice(0, 10)},
                         {tier_type_id: 3, tier_to_show:1, date_change: new Date().toISOString().slice(0, 10)},
                         {tier_type_id: 2, tier_to_show:0, date_change: new Date().toISOString().slice(0, 10)},
                         {tier_type_id: 4, tier_to_show:1,date_change: new Date().toISOString().slice(0, 10)},
                         {tier_type_id: 5, date_change: new Date().toISOString().slice(0, 10)}
                    ]},
                    snackbar:{open:false}, loading: true,tier_brands:[],tier_variations:[]}
  	}

    async componentDidMount() {
    	var work_order_id = this.props.work_order_id
        await this.getTierVariations();
        await this.getTierBrands();
    	await this.getWorkOrderTierChanges(work_order_id)
    	this.setState({loading: false})
    }

   	async getWorkOrderTierChanges(id){
		const token = localStorage.getItem('userToken')
		return await axios
	     .get(api.work_order_tier_changes().get(id),{ headers: {"Authorization" : `Bearer ${token}`} })
	      .then(res => {
	      		var work_order_tier_changes = this.state.work_order_tier_changes
                if (res.data.length > 0){
                    work_order_tier_changes.tiers.map((val,idx)=>{
                        work_order_tier_changes.tiers[idx].date_change = ''
                    });
                    work_order_tier_changes.tiers_to_show = 4
                }
                var has_front_tiers = false
                var has_back_tiers = false
                res.data.map((val, idx)=>{
                    work_order_tier_changes.tiers.map((val2,idx2)=>{
                        var tier_to_show = 4
                        val.id = parseInt(val.id)
                        val.tier_type_id = parseInt(val.tier_type_id)
                        val2.tier_type_id = parseInt(val2.tier_type_id)
                        if (val.tier_type_id === val2.tier_type_id){
                            work_order_tier_changes.tiers[idx2] = val
                        }
                        if (val.tier_type_id === 1 || val.tier_type_id === 2){
                            tier_to_show = 0 
                            has_front_tiers = true
                        }
                        if (val.tier_type_id === 3 || val.tier_type_id === 4){
                            tier_to_show = 1 
                            has_back_tiers = true
                        }
                        if (val.reason && val.reason !== ''){
                            work_order_tier_changes.reason = val.reason
                        }
                        work_order_tier_changes.tiers_to_show = tier_to_show
                    })    
                })
                if (has_front_tiers && has_back_tiers){
                    work_order_tier_changes.tiers_to_show = 4
                }   
                if (work_order_tier_changes.tiers.filter(t => t.id > 0 ).length === 1)
                    work_order_tier_changes.tiers_to_show = 5

                this.setState({work_order_tier_changes: work_order_tier_changes, loading: false})
	      })
	      .catch(err =>{console.log(err)
	      })
    }

    async getTierBrands(id){
		const token = localStorage.getItem('userToken')
		return await axios
	     .get(api.vehicles().tier_brands(),{ headers: {"Authorization" : `Bearer ${token}`} })
	      .then(res => {
	      		var tier_brands = res.data
	      		this.setState({tier_brands: tier_brands})
	      })
	      .catch(err =>{console.log(err)
	      })
    }

    async getTierVariations(id){
     const token = localStorage.getItem('userToken')
     return await axios
      .get(api.vehicles().tier_variations(),{ headers: {"Authorization" : `Bearer ${token}`} })
       .then(res => {
               var tier_variations = res.data
               tier_variations.push({variation_id:0, name:'Nuevo modelo'})
               this.setState({tier_variations: tier_variations})
       })
       .catch(err =>{console.log(err)
       })
    }
    
    handleChange = (e) =>{
    	var work_order_tier_changes = this.state.work_order_tier_changes

        if (e.target.name !== 'tiers_to_show' && e.target.name !== 'reason_type' ){
            var res = e.target.name.split(".");
            var key = res[1];
            var id = res[0];
            work_order_tier_changes.tiers.map((tier, idx)=> {
                if (parseInt(work_order_tier_changes.tiers_to_show) === 5){
                    if (parseInt(tier.tier_type_id) === parseInt(id)){
                        work_order_tier_changes.tiers[idx][key] = e.target.value
                        if (work_order_tier_changes.tiers[idx].id > 0 && e.target.value === ''){
                            work_order_tier_changes.tiers[idx]['deleted_at'] = 1;
                        }
                    }
                } else {
                    if (parseInt(tier.tier_type_id) === parseInt(id)){
                        work_order_tier_changes.tiers[idx][key] = e.target.value
                    }
                    if (parseInt(tier.tier_to_show) === parseInt(work_order_tier_changes.tiers_to_show) || (work_order_tier_changes.tiers_to_show === 4) ){
                        if (tier.tier_type_id !== 5){
                            work_order_tier_changes.tiers[idx][key] = e.target.value
                        }
                    }
                }
            })
        } else if (e.target.name === 'reason_type'){
            work_order_tier_changes.reason = e.target.value
        } else {
            work_order_tier_changes.tiers_to_show = parseInt(e.target.value)
        }

    	this.setState({work_order_tier_changes: work_order_tier_changes})
    }

	handleRestore = async (e) => {
	    const token = localStorage.getItem('userToken')
		let self = this
		return await axios
		  .get(api.work_order_tier_changes().restart(this.props.work_order_id),{ headers: {"Authorization" : `Bearer ${token}`} })
	      .then((response)=> {
	      		var snackbar = {open: true, success_message: 'Cubiertas reinicados con éxito', severity: 'success'}
		  		self.setState({ snackbar: snackbar})
				self.getValet(this.props.id)
				this.props.onUpdateWorkOrderState();
	      })
	      .catch(function (error) {
//	      		var error_message = 'Ha ocurrido un error al cargar el movimiento. Por favor contacte con su administrador'
	      		var error_message = ''
	      		var errors = error.response.data
				if (errors.errors){
					if (errors.errors.status_code !== 404){
					  var keys = Object.keys(errors.errors); 
					  for(var i = 0; i < keys.length; i++) {   
					    var key = (keys[i]) ; 
					    var key_errors = errors.errors[key]
					    key_errors.map((val,idx)=>{
					      error_message = error_message.concat(val).concat(' ')
					    })
					  }
					} else {
				      error_message = error_message.concat(errors.errors.message).concat(' ')
					}
				}

	      		var snackbar = {open: true, success_message: error_message, severity: 'warning'}
		  		self.setState({ snackbar: snackbar})
	    })		
	}    
   handleSubmit = () => {
	    var formData = new FormData();
	    var url = api.work_order_tier_changes().post();
        var idx = 0
	    this.state.work_order_tier_changes.tiers.map((val,idx)=>{
            val.tier_type_id = parseInt(val.tier_type_id)
            if (val.tier_type_id > 0 && val.tier_variation_id !== undefined && val.tier_variation_id !== ''){
                val.tier_variation_id = parseInt(val.tier_variation_id)
                formData.set("work_order_tier_changes[" + idx + "][work_order_id]", this.props.work_order_id);
                formData.set("work_order_tier_changes[" + idx + "][tier_type_id]", (val.tier_type_id) ? val.tier_type_id : '');
                formData.set("work_order_tier_changes[" + idx + "][tier_variation_id]", (val.tier_variation_id) ? val.tier_variation_id : '' );
                formData.set("work_order_tier_changes[" + idx + "][date_change]", (val.date_change) ? val.date_change : '');
				formData.set("work_order_tier_changes["+ idx +"][tier_variation_wheel]", val.tier_variation_wheel || '' );
				formData.set("work_order_tier_changes["+ idx +"][tier_variation_anchor]", val.tier_variation_anchor || '' );
				formData.set("work_order_tier_changes["+ idx +"][tier_variation_size]", val.tier_variation_size || '' );
				formData.set("work_order_tier_changes["+ idx +"][tier_variation_brand_id]", val.tier_variation_brand_id || '' );
				formData.set("work_order_tier_changes["+ idx +"][tier_variation_name]", val.tier_variation_name || '' );
				formData.set("work_order_tier_changes["+ idx +"][reason]", this.state.work_order_tier_changes.reason || '' );

                if (val.id > 0){
                    formData.set("work_order_tier_changes[" + idx + "][id]", val.id);
                }
                idx++;
            }

            if (val.deleted_at){
				formData.set("work_order_tier_changes["+ idx +"][id]", val.id );
				formData.set("work_order_tier_changes["+ idx +"][tier_variation_id]", null);
				formData.set("work_order_tier_changes["+ idx +"][deleted_at]", new Date().toISOString().slice(0, 19).replace('T', ' ') );
            }
        })
	    if (this.state.work_order_tier_changes.id !== undefined) {
	    	url = api.work_order_tier_changes().patch(this.props.id)
		    formData.set("work_order_tier_changes[id]", this.state.work_order_tier_changes.id);
		    formData.set("_method", 'PATCH');
	    }
	    let self = this
	    const token = localStorage.getItem('userToken')
	    axios.post(url,
	       formData,
	       {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
	       )
	      .then((response)=> {
	      		var snackbar = {open: true, success_message: 'Cambio de cubiertas cargado con éxito', severity: 'success'}
		  		self.setState({ snackbar: snackbar})

	      })
	      .catch(function (error) {
	      		var error_message = ''
	      		var errors = error.response.data
				if (errors.errors){
					if (errors.status_code !== 404){
					  var keys = Object.keys(errors.errors); 
					  for(var i = 0; i < keys.length; i++) {   
					    var key = (keys[i]) ; 
					    var key_errors = errors.errors[key]
					    key_errors.map((val,idx)=>{
					      error_message = error_message.concat(val).concat(' ')
					    })
					  }
					} else {
				      error_message = error_message.concat(error.message).concat(' ')
					}
				}

	      		var snackbar = {open: true, success_message: error_message, severity: 'warning'}
		  		self.setState({ snackbar: snackbar})
	    })
    }

    handleSnackbar = () => {
    	var snackbar = this.state.snackbar
    	snackbar.open = !snackbar.open
    	this.setState({snackbar: snackbar})
    }

	render() {
		var work_order_tier_changes = this.state.work_order_tier_changes
        const disabled = this.props.disabled
		const classes = this.props.classes;
        const tier_brands = this.state.tier_brands
        const tier_variations = this.state.tier_variations
        const tiers_to_show = [{'id': 0, name: 'Delanteras'},{'id': 1, name: 'Traseras'},{'id': 3, name: 'Auxilio'},{'id': 4, name: 'Todas'},{'id':5, name:'Individual'}]
        const reason_types = [{id:'Desgaste', name:'Desgaste'},{id:'Rotura',name:'Rotura'},{id:'Robo',name:'Robo'}]
		return (
			<React.Fragment>
				<Snackbar open={this.state.snackbar.open} autoHideDuration={10000} onClose={this.handleSnackbar}>
					<Alert onClose={this.handleSnackbar} severity={this.state.snackbar.severity}>
					  {this.state.snackbar.success_message}
					</Alert>
				</Snackbar>
                
				{(this.state.loading)
					?
					''
					:
					<React.Fragment>
                        <Typography variant="h6" className="mt-2">
                            Cambio de cubiertas
                            <FormControl className="" style={{minwidth: 120, fontSize: '0.75rem'}} name={"tiers_to_show"} >
                                <Select native name={".tiers_to_show"}
                                    inputProps={{
                                        name:"tiers_to_show",
                                        className:"tiers_to_show"
                                    }}
                                    style={{minwidth: 120, fontSize: '0.75rem', marginLeft: '8px'}}
                                    value={work_order_tier_changes.tiers_to_show}
                                    onChange={this.handleChange}
                                    input={<Input id="grouped-native-select" name={'tiers_to_show'}/>}>
                                    <option value="" />
                                    {tiers_to_show.map((tiers_to_sho) =>
                                        <option id={tiers_to_sho.id} value={tiers_to_sho.id}>{tiers_to_sho.name}</option>
                                    )}
                                </Select>
                            </FormControl>
                            <TextField
                                id="reason_type"
                                name="reason_type"
                                select
                                margin="normal"
                                className="ml-2 mr-2 mt-0"
                                InputLabelProps={{
                                    shrink: true
                                }}
                                onChange={this.handleChange}
                                value={work_order_tier_changes.reason}
                                inputProps={{style:{minWidth: 30, fontSize: '0.75rem'}}}
                                InputProps={{
                                    startAdornment: <InputAdornment position="start" ><Typography variant="caption" style={{width: 55}}>Motivo </Typography></InputAdornment>,
                                    style:{fontSize: '0.75rem'}
                                }}
                            >
                            {reason_types.map((option) => (
                                <MenuItem key={option.id} value={option.id} className={classes.menu}>
                                {option.name}
                                </MenuItem>
                            ))}
                            </TextField>
                        </Typography>
						<div className="row mt-2"> 
                            <div className="col-11 mr-auto">
                                <div className="row">
                                <div className="col-4 ml-auto">
                                    <Tier title={'Delantera izquierda'} tier_variations={tier_variations} tier_brands={tier_brands} tier={work_order_tier_changes.tiers[0]} onChange={this.handleChange} display={(work_order_tier_changes.tiers_to_show === 0 || work_order_tier_changes.tiers_to_show === 4 || work_order_tier_changes.tiers_to_show === 5)} display_next_fields={work_order_tier_changes.tiers[0].display_next_fields} disabled={disabled}/>
                                    <Tier title={'Trasera izquierda'} tier_variations={tier_variations} tier_brands={tier_brands} tier={work_order_tier_changes.tiers[1]} onChange={this.handleChange} display={(work_order_tier_changes.tiers_to_show === 1 || work_order_tier_changes.tiers_to_show === 4 || work_order_tier_changes.tiers_to_show === 5)} display_next_fields={work_order_tier_changes.tiers[1].display_next_fields} disabled={disabled} />
                                </div>
                                <div className="col-2 p-0 mx-auto">
                                    <img src="../../../../car.svg" />
                                </div>
                                <div className="col-4">
                                    <Tier title={'Delantera derecha'} tier_variations={tier_variations} tier_brands={tier_brands} tier={work_order_tier_changes.tiers[2]} onChange={this.handleChange}  display={(work_order_tier_changes.tiers_to_show === 0 || work_order_tier_changes.tiers_to_show === 4 || work_order_tier_changes.tiers_to_show === 5)} display_next_fields={work_order_tier_changes.tiers[2].display_next_fields} disabled={disabled}/>
                                    <Tier title={'Trasera derecha'} tier_variations={tier_variations} tier_brands={tier_brands} tier={work_order_tier_changes.tiers[3]} onChange={this.handleChange}  display={(work_order_tier_changes.tiers_to_show === 1 || work_order_tier_changes.tiers_to_show === 4 || work_order_tier_changes.tiers_to_show === 5)} display_next_fields={work_order_tier_changes.tiers[3].display_next_fields}  disabled={disabled}/>
                                </div>
                                </div>
                            </div>
                            <div className="col-4 mx-auto text-left">
                                <Tier title={'Auxilio'} tier_variations={tier_variations} tier_brands={tier_brands} tier={work_order_tier_changes.tiers[4]} onChange={this.handleChange}  display={(work_order_tier_changes.tiers_to_show === 3 || work_order_tier_changes.tiers_to_show === 4 || work_order_tier_changes.tiers_to_show === 5)} display_next_fields={work_order_tier_changes.tiers[4].display_next_fields || true}  disabled={disabled}/>
                            </div>
						</div>	
						<div className="row mt-2">
							<Button disabled={disabled} className="mt-1" variant="contained" color="primary" size="small" style={{fontSize: '0.75rem'}} onClick={(e)=>{this.handleSubmit(e)}}>{(this.state.work_order_tier_changes.id) ? 'Guardar' : 'Cargar'}</Button>
                            {!disabled && (
                                work_order_tier_changes.tiers[0].id ||
                                work_order_tier_changes.tiers[1].id ||
                                work_order_tier_changes.tiers[2].id ||
                                work_order_tier_changes.tiers[3].id ||
                                work_order_tier_changes.tiers[4].id
                            ) &&
                                <Button className="ml-2 mt-1" variant="contained" color="primary" size="small" style={{fontSize: '0.75rem'}} onClick={(e)=>{this.handleRestore(e)}}>
                                    Reiniciar cubiertas
                                </Button>
                            }
						</div>
					</React.Fragment>
				}
			</React.Fragment>
		)
	}

}

export default withStyles(useStyles)(TierChanges);

